import { Atom } from "@effect-atom/atom";
import type { Engine } from "../lib/schemas";

// Dark mode
export const darkModeAtom = Atom.make(
  window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false
);

// Engine selection
export const selectedEngineAtom = Atom.make<Engine>("Saxon12");

// Loading states
export const isTransformingAtom = Atom.make(false);
export const isSavingAtom = Atom.make(false);

// Status messages
export const transformStatusAtom = Atom.make("Ready");
export const saveMessageAtom = Atom.make("");
export const transformationTimeAtom = Atom.make<number | null>(null);

// API connection status - set by loadDefaultsAtom
export const apiConnectedAtom = Atom.make<boolean | null>(null);

// Auto-transform on content change
export const autoTransformEnabledAtom = Atom.make(false);

// Show/hide tabs
export const showHtmlTabAtom = Atom.make(false);
export const showPdfTabAtom = Atom.make(false);
export const showConsoleAtom = Atom.make(false);

// PDF content (base64)
export const pdfContentAtom = Atom.make<string | null>(null);

// Console messages from xsl:message
export const consoleMessagesAtom = Atom.make<string[]>([]);

// Responsive layout
export const splitPositionAtom = Atom.make(50); // percentage (0-100)
export const isMobileViewAtom = Atom.make(window.innerWidth < 1024);

// Unified tab for mobile view
export type UnifiedTab = "xml" | "xsl" | "result" | "html" | "pdf" | "console";
export const unifiedTabAtom = Atom.make<UnifiedTab>("xml");
